(() => {
  const root = document.querySelector('[data-payment-installment-tabs]');
  if (!root) return;

  if (!window._affirm_config) {
    window._affirm_config = {
      public_api_key: 'PH9LWGD5DNG5CR1E',
      script: 'https://cdn1.affirm.com/js/v2/affirm.js',
    };

    (function (l, g, m, e, a, f, b) {
      var d;
      var c = l[m] || {};
      var h = document.createElement(f);
      var n = document.getElementsByTagName(f)[0];
      var k = function (api, method, name) {
        return function () {
          api[method]._.push([name, arguments]);
        };
      };
      c[e] = k(c, e, 'set');
      d = c[e];
      c[a] = {};
      c[a]._ = [];
      d._ = [];
      c[a][b] = k(c, a, b);
      a = 0;
      for (b = 'set add save post open empty reset on off trigger ready setProduct'.split(' '); a < b.length; a++) {
        d[b[a]] = k(c, e, b[a]);
      }
      a = 0;
      for (b = ['get', 'token', 'url', 'items']; a < b.length; a++) d[b[a]] = function () {};
      h.async = true;
      h.src = g[f];
      n.parentNode.insertBefore(h, n);
      delete g[f];
      d(g);
      l[m] = c;
    })(window, window._affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready');
  }

  const wrap = root.querySelector('[data-payment-affirm-wrap]');
  const ala = root.querySelector('[data-payment-affirm-ala]');

  const isAffirmReady = () => {
    if (!wrap) return false;
    const hasCopy =
      Boolean(wrap.querySelector('.affirm-modal-trigger, .__affirm-logo, .affirm-ala-price')) ||
      Boolean(ala?.textContent.trim());
    if (hasCopy) wrap.classList.add('is-loaded');
    return hasCopy;
  };

  const refreshAffirm = () => {
    if (window.affirm?.ui?.refresh) {
      window.affirm.ui.refresh();
    }
    isAffirmReady();
  };

  if (wrap) {
    const observer = new MutationObserver(() => {
      if (isAffirmReady()) observer.disconnect();
    });
    observer.observe(wrap, { childList: true, subtree: true, characterData: true });
  }

  if (window.affirm?.ui?.ready) {
    window.affirm.ui.ready(refreshAffirm);
  }

  let attempts = 0;
  const poll = window.setInterval(() => {
    refreshAffirm();
    attempts += 1;
    if (isAffirmReady() || attempts > 20) window.clearInterval(poll);
  }, 250);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const price = event.data?.variant?.price;
      if (ala && price != null) {
        ala.setAttribute('data-amount', String(price));
        refreshAffirm();
      }
    });
  }
})();
